/*
Componente para mostrar un mensaje de confirmación
*/

import React, { useEffect } from 'react'

// #region CSS
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
// #endregion

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

export default function AlertDialog({ children, show, setShow }) {
  const [open, setOpen] = React.useState(false)

  const handleClose = () => {
    setOpen(false)
    setShow(false)
  }

  useEffect(() => {
    setOpen(show)
  }, [show])

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'
      >
        <DialogContent>
          {children}
        </DialogContent>
        <DialogActions>
          <Button data-lang="ok" onClick={handleClose} color='primary'>
            Vale
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
